import { useMemo, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchYearSingleForm } from "src/components/common/form/search/SearchYearSingleForm";
import { useTQC2080_R01Store } from "./Store_TQC2080_R01";

const parseYearToDate = (yearStr: string): Date | undefined => {
	const y = Number(yearStr);
	if (!Number.isFinite(y) || y < 1000 || y > 9999) return undefined;
	return new Date(y, 0, 1);
};

export const SearchSection_TQC2080_R01 = () => {
	const { TQC2080_R01Filter, setTQC2080_R01Filter } = useTQC2080_R01Store();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const yearValue = useMemo(
		() => parseYearToDate(TQC2080_R01Filter.year),
		[TQC2080_R01Filter.year],
	);

	return (
		<SearchSectionForm>
			<SearchYearSingleForm
				label="연도"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={yearValue}
				onChange={(d) => {
					if (d) setTQC2080_R01Filter({ year: String(d.getFullYear()) });
				}}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
		</SearchSectionForm>
	);
};
